import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { IAppliedFilter } from 'src/app/interface/applied-filter';
import { IFilterResponse } from 'src/app/interface/filter-response';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';
import { ApplicationService } from 'src/app/services/http/application.service';
import { ApplicationCreateEditComponent } from '../application-management/application-create-edit/application-create-edit.component';
import { AuditLogService } from 'src/app/services/http/auditlog.service';

@Component({
  selector: 'app-auditlog-management',
  templateUrl: './auditlog-management.component.html',
  styleUrls: ['./auditlog-management.component.scss']
})
export class AuditlogManagementComponent {
  @ViewChild(ApplicationCreateEditComponent) popupComponentRef!: ApplicationCreateEditComponent;
  @ViewChild(ModalConfirmComponent) confirmModal!: ModalConfirmComponent;

  appliedFilters: IAppliedFilter[] = []
  searchInput: string = '';
  public currentPage: number = 1;
  public pageSize: number = 10;
  public count: number = 0;
  public auditLogs: any[] = []

  ngOnInit(): void {
    this.reloadTable();
  }

  constructor(private auditLogService: AuditLogService,
    private toastr: ToastrService) { }

  handleChangeFilter(appliedFilters: IFilterResponse) {
    this.appliedFilters = appliedFilters.filters;
    this.searchInput = appliedFilters.searchFilter;
    this.currentPage = 1;
    this.reloadTable()
  }

  pageChange(value: number) {
    this.currentPage = value
    this.reloadTable()
  }

  reloadTable(page: any = null) {
    if (page)
      this.currentPage = page;

    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      search: this.searchInput
    };

    this.auditLogService.getAll(obj).subscribe(response => {
      this.auditLogs = response.data.data;
      this.count = response.data.count;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  
}
